import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = ({ hasArrow = true }) => ({
  default: {
    thBody: classnames('mt-15 border-1 border-lightGrey bg-white p-10 shadow-lg', {
      'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow,
    }),
  },
  hollow: {
    thBody: classnames('rounded-12 border-1 border-lightGrey bg-white shadow-lg', {
      'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow,
    }),
  },
});
